import { render, staticRenderFns } from "./scalePieCharts.vue?vue&type=template&id=35c6b3ca"
import script from "./scalePieCharts.vue?vue&type=script&lang=js"
export * from "./scalePieCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports